<template>
  <md-input-item v-model="innerValue" :type="type" :title="title" :name="name" :placeholder="placeholder" :error="error" :align="align"
    @blur="onBlur" :is-title-latent="isTitleLatent">
      <slot name="left" slot="left"></slot>
    </md-input-item>
</template>

<script>
export default {
  name: 'inputValidate',
  props: {
    value: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    title: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    align: {
      type: String,
      default: "left"
    },
    error: {
      type: String,
      default: ""
    },
    isTitleLatent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerValue: ""
    };
  },
  watch: {
    value: {
      handler(val) {
        this.innerValue = val;
      },
      immediate: true
    },
    innerValue(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    onBlur() {
      this.$emit("blur");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/input-validate.vue